export const STORAGE_COLUMNS_CONFIG_KEY = "tableName";
export const STORAGE_TOKEN_KEY = 'token';
export const MAX_UPLOAD_FILE_SIZE = 2 * 1024 * 1024; //2MB
export const MAX_INPUT_TEXT_LENGTH = 1000;
export const MIN_INPUT_TEXT_LENGTH_TO_SHOW_MEASURER = 120
export const FORMATED_CPF_LENGTH = 14
export const FORMATED_CNPJ_LENGTH = 18
export const FORMATED_CEP_LENGTH = 10
export const UNFORMATED_CEP_LENGTH = 8
export const CNPJ_MAX_LENGTH = 18;
export const RG_MAX_LENGTH = 12;
export const IE_MAX_LENGTH = 15;
export const PHONE_LENGTH = 10
export const DEFAULT_NOT_INPUTED_DATA = "1800-01-01"
export const MIN_SEARCH_TEXT_LENGTH = 3;
export const DEFAULT_BRAZIALIAN_UF_LENGTH = 2
export const MIN_TOKEN_LENGTH = 32
export const CURRENCY_INPUT_MAX_LENGTH = 17
export const SIGNATURES_CATEGORY = "assinaturas"

export const PERSON_FIELD_LIMITS = {
    nomeRazaoSocial: 100,
    apelidoNomeFantasia: 55,
    estadoCivil: 13,
    conjugeNome: 50,
    paiNome: 50,
    maeNome: 50,
    conjugeRg: 20,
    conjugeCpf: 20,
    profissao: 50,
    nacionalidade: 20,
    localTrabalho: 50
};

export const MONTHS_OPTIONS = [
    { label: 'Janeiro', value: 'janeiro' },
    { label: 'Fevereiro', value: 'fevereiro' },
    { label: 'Março', value: 'marco' },
    { label: 'Abril', value: 'abril' },
    { label: 'Maio', value: 'maio' },
    { label: 'Junho', value: 'junho' },
    { label: 'Julho', value: 'julho' },
    { label: 'Agosto', value: 'agosto' },
    { label: 'Setembro', value: 'setembro' },
    { label: 'Outubro', value: 'outubro' },
    { label: 'Novembro', value: 'novembro' },
    { label: 'Dezembro', value: 'dezembro' }
]

export const EMAIL_DEFAULT = "gestaoxnestjs@gmail.com"

export const searchCepCorreiosURL = "https://buscacepinter.correios.com.br/app/endereco/index.php"

export const DAYS_OF_WEEK_OPTIONS = [
    { label: 'Domingo', value: 'domingo' },
    { label: 'Segunda', value: 'segunda' },
    { label: 'Terça', value: 'terca' },
    { label: 'Quarta', value: 'quarta' },
    { label: 'Quinta', value: 'quinta' },
    { label: 'Sexta', value: 'sexta' },
    { label: 'Sábado', value: 'sabado' }
]

export const BRAZILIAN_STATES = [
    { label: 'Acre', value: 'AC' },
    { label: 'Alagoas', value: 'AL' },
    { label: 'Amapá', value: 'AP' },
    { label: 'Amazonas', value: 'AM' },
    { label: 'Bahia', value: 'BA' },
    { label: 'Ceará', value: 'CE' },
    { label: 'Distrito Federal', value: 'DF' },
    { label: 'Espírito Santo', value: 'ES' },
    { label: 'Goiás', value: 'GO' },
    { label: 'Maranhão', value: 'MA' },
    { label: 'Mato Grosso', value: 'MT' },
    { label: 'Mato Grosso do Sul', value: 'MS' },
    { label: 'Minas Gerais', value: 'MG' },
    { label: 'Pará', value: 'PA' },
    { label: 'Paraíba', value: 'PB' },
    { label: 'Paraná', value: 'PR' },
    { label: 'Pernambuco', value: 'PE' },
    { label: 'Piauí', value: 'PI' },
    { label: 'Rio de Janeiro', value: 'RJ' },
    { label: 'Rio Grande do Norte', value: 'RN' },
    { label: 'Rio Grande do Sul', value: 'RS' },
    { label: 'Rondônia', value: 'RO' },
    { label: 'Roraima', value: 'RR' },
    { label: 'Santa Catarina', value: 'SC' },
    { label: 'São Paulo', value: 'SP' },
    { label: 'Sergipe', value: 'SE' },
    { label: 'Tocantins', value: 'TO' }
];

// =/=/=/=/=/=/=/=
//   Kanban
// =/=/=/=/=/=/=/=

export enum FaseLead {
    NOVO_LEAD = "Novo Lead / Entrada",
    QUALIFICACAO = "Qualificação",
    PRIMEIRO_CONTATO = "Primeiro Contato",
    EM_ATENDIMENTO = "Em Atendimento / Prospecção Ativa",
    VISITA_AGENDADA = "Visita Agendada / Realizada",
    EM_NEGOCIACAO = "Em Negociação",
    PRE_VENDA = "Pré-venda / Documentação",
    VENDA_CONCLUIDA = "Venda Concluída",
    PERDIDO = "Perdido / Lead Frio / Sem Retorno",
}

export enum PrioridadeLead {
    URGENTE = "urgente",
    ALTA = "alta",
    NORMAL = "normal",
    BAIXA = "baixa",
}

export const priorityColors: Record<string, { color: string; label: string }> = {
    [PrioridadeLead.URGENTE]: {
        color: "text-red-500",
        label: "Urgente"
    },
    [PrioridadeLead.ALTA]: {
        color: "text-yellow-500",
        label: "Alta"
    },
    [PrioridadeLead.NORMAL]: {
        color: "text-sky-500",
        label: "Normal"
    },
    [PrioridadeLead.BAIXA]: {
        color: "text-gray-500",
        label: "Baixa"
    },
};

export const statusColors: Record<string, { strong: string; light: string }> = {
    "Novo Lead / Entrada": {
        strong: "bg-blue-400",
        light: "bg-blue-100",
    },
    "Qualificação": {
        strong: "bg-green-400",
        light: "bg-green-100",
    },
    "Primeiro Contato": {
        strong: "bg-purple-400",
        light: "bg-purple-100",
    },
    "Em Atendimento / Prospecção Ativa": {
        strong: "bg-yellow-400",
        light: "bg-yellow-100",
    },
    "Visita Agendada / Realizada": {
        strong: "bg-pink-400",
        light: "bg-pink-100",
    },
    "Em Negociação": {
        strong: "bg-cyan-400",
        light: "bg-cyan-100",
    },
    "Pré-venda / Documentação": {
        strong: "bg-orange-400",
        light: "bg-orange-100",
    },
    "Venda Concluída": {
        strong: "bg-lime-400",
        light: "bg-lime-100",
    },
    "Perdido / Lead Frio / Sem Retorno": {
        strong: "bg-red-500",
        light: "bg-red-100",
    },
};

export const numberOfLeadsToGenerateOptions = [
    { value: 10, label: "1-10" },
    { value: 20, label: "11-20" },
    { value: 30, label: "21-30" }
]



